import { render, staticRenderFns } from "./my-button.vue?vue&type=template&id=83cde40c&scoped=true"
import script from "./my-button.vue?vue&type=script&lang=js"
export * from "./my-button.vue?vue&type=script&lang=js"
import style0 from "./my-button.vue?vue&type=style&index=0&id=83cde40c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cde40c",
  null
  
)

export default component.exports